export default {
  'suppliers.searchBar.button': 'Create New Supplier',
  'suppliers.searchBar.generateReport': 'Generate Report',
  'suppliers.list.header.cpfCnpj': 'CPF/CNPJ',
  'suppliers.list.header.name': 'Name',
  'suppliers.list.header.email': 'E-mail',
  'suppliers.list.header.phone': 'Phone',
  'suppliers.list.header.actions': 'Actions',
  'suppliers.list.column.actions.button': 'View/Edit',
  'suppliers.filters.active': 'Active',
  'suppliers.filters.active.options.all': 'All',
  'suppliers.filters.active.options.active': 'Active',
  'suppliers.filters.active.options.inactive': 'Inactive',
  'suppliers.filters.cpfCnpj': 'CPF/CNPJ',
  'suppliers.filters.product': 'Product',
  'suppliers.filters.nickName': 'Nickname',
  'suppliers.filters.order': 'Order by',
  'suppliers.filters.order.options.asc': 'Asc',
  'suppliers.filters.order.options.desc': 'Desc',

  'suppliers.modal.report.title': 'Generate Report',
  'suppliers.modal.report.buttons.viewReport': 'View Report',
  'suppliers.modal.report.buttons.pdf': 'Generate PDF',
  'suppliers.modal.report.buttons.rtf': 'Generate RTF',
  'suppliers.modal.report.buttons.csv': 'Generate CSV',
  'suppliers.modal.report.form.type': 'Type',
  'suppliers.modal.report.form.situation': 'Situation',
  'suppliers.modal.report.form.state': 'State',
  'suppliers.modal.report.form.city': 'City',
  'suppliers.modal.report.form.pieces': 'Pieces type',
  'suppliers.modal.report.form.pieces': 'Parts line',
  'suppliers.notification.generate.report.title':
    'Report Generated Successfully',
  'suppliers.notification.generate.report.description':
    'Successfully Generated Supplier Report!',

  'suppliers.general.form.name': 'Name',
  'suppliers.general.form.type': 'Type',
  'suppliers.general.form.type.individual': 'Individual',
  'suppliers.general.form.type.legalPerson': 'Legal Person',
  'suppliers.general.form.cnpj': 'CNPJ',
  'suppliers.general.form.nickName': 'Nickname',
  'suppliers.general.form.stateRegistration': 'State Registration',
  'suppliers.general.form.municipalRegistration': 'Municipal Registration',
  'suppliers.general.form.classification': 'Classification',
  'suppliers.general.form.classification.dealership': 'Dealership',
  'suppliers.general.form.classification.distributor': 'Distributor',
  'suppliers.general.form.classification.retail': 'Retail',
  'suppliers.general.form.classification.wholesale': 'Wholesale',
  'suppliers.general.form.classification.others': 'Others',
  'suppliers.general.form.email': 'Email',
  'suppliers.general.form.webSite': 'Web Site',
  'suppliers.general.form.note': 'Notes',
  'suppliers.general.form.situation': 'Situation',
  'suppliers.general.form.situation.active': 'Active',
  'suppliers.general.form.situation.inactive': 'Inactive',
  'suppliers.general.form.product': 'Product',
  'suppliers.general.form.telephones': 'Telephones',
  'suppliers.general.form.phoneCompany': 'Phone Company',
  'suppliers.general.form.newContact': 'Novo Contato',

  'suppliers.general.form.planAccount': 'Plan Account',
  'supplier.modal.button.saveAddress': 'Save Address',

  'suppliers.notifications.create.success.title':
    'Supplier registered successfully!',
  'suppliers.notifications.create.success.description':
    'The new supplier has been registered successfully.',

  'suppliers.activate.message.success': 'Supplier Activated Successfully!',
  'suppliers.inactivate.message.success': 'Supplier Successfully Inactivated!',
  'suppliers.remove': 'Remove Supplier',
  'suppliers.remove.modal.content':
    'Do you really want to remove the Supplier?',
  'suppliers.remove.modal.button.ok': 'Remove',
  'suppliers.remove.notification.success': 'Supplier Removed',
  'suppliers.remove.notification.successDescription':
    'Supplier was successfully removed',

  'suppliers.address.create.notification.success': 'Success',
  'suppliers.address.create.notification.successDescription':
    'Address created.',

  'suppliers.contacts.remove': 'Remove Contact',
  'suppliers.contacts.remove.alert':
    'Do you really want to remove the contact:',

  'suppliers.address.update.notification.success': 'Success',
  'suppliers.address.update.notification.successDescription':
    'Updated address.',

  'suppliers.address.remove': 'Remove Address',
  'suppliers.address.remove.alert': 'Do you really want to remove the address:',
  'suppliers.address.remove.notification.success': 'Success',
  'suppliers.address.remove.notification.successDescription':
    'Address removed.',

  'suppliers.column.address.zipCode': 'CEP',
  'suppliers.column.address.street': 'Street',
  'suppliers.column.address.complement': 'Complement',
  'suppliers.modal.selectedSuppliers.title.add': 'Add Supplier',
  'suppliers.modal.selectedSuppliers.search': 'Search for Suppliers',
};
